<template>

  <footer class="hit-footer hit-html-html">

  	<div class="hit-navbar hit-navbar-inverse hit-navbar-small">
      <div class="hit-container" style="padding: 20px;">
        <div class="hit-row">
          <div class="hit-col-md-12">
            <logo :id="2" style="font-size: 4em; color: white;"/>
          </div>
        </div>
      </div>
    </div>

    <div class="hit-navbar hit-navbar-inverse hit-navbar-small" style="background-color: #333; border-color: #333; font-size: 12pt;">
      <div class="hit-container" style="margin-top: 30px;">
        <div class="hit-row">

          <div class="hit-col-md-3 hit-col-xs-12">

            <h5 class="hit-html-h5">{{ get_version() }} &copy; {{ $t("company.name") }}, {{ get_year() }}</h5>

            <changeLanguage class="hit-text-primary" />

          </div>

        <div class="hit-col-md-2  hit-col-xs-4 hit-text-center">

          <div class="hit-widget-container hit-widget_nav_menu">

            <h4 class="title-widget">{{ $t("message.home") }}</h4>

              <ul class="hit-list-unstyled hit-clear-margins">

                <li class="hit-html-li "><router-link class="hit-html-a hit-text-primary" @click.native="scroll_top()" :to="{ name: 'home', params: {lang: $store.getters.lang} }">{{ $t("message.home") }}</router-link></li>
                <li class="hit-html-li "><router-link class="hit-html-a hit-text-primary" @click.native="scroll_top()" :to="{ name: 'contact', params: {lang: $store.getters.lang} }">{{ $t("message.contact") }}</router-link></li>

              </ul>

          </div>

        </div>

        <div class="hit-col-md-2 hit-col-xs-4 hit-text-center">

          <div class="hit-widget-container hit-widget_nav_menu">

          <h4 class="hit-title-widget">{{ $t("message.signUp") }}</h4>

              <ul class="hit-list-unstyled hit-clear-margins">

                <li class="hit-html-li "><router-link  class="hit-html-a hit-text-primary" :to="{ name: 'sign_in', params: {lang: $store.getters.lang} }">{{ $t('message.signIn') }}</router-link></li>
                <li class="hit-html-li "><router-link class="hit-html-a hit-text-primary" :to="{ name: 'sign_up', params: {lang: $store.getters.lang} }">{{ $t('message.signUp') }}</router-link></li>

                <li v-if="$store.getters.user" class="hit-html-li"><router-link  class="hit-html-a hit-text-primary" @click.native="scroll_top()" :to="{ name: 'app', params: {lang: $store.getters.lang} }">{{ $t('message.dashboard') }}</router-link></li>
                <li v-if="$store.getters.user" class="hit-html-li"><router-link  class="hit-html-a hit-text-primary" @click.native="scroll_top()" :to="{ name: 'sign_in', params: {lang: $store.getters.lang} }">{{ $t('message.logout') }}</router-link></li>

              </ul>

          </div>

        </div>

        <div class="hit-col-md-2 hit-col-xs-4 hit-text-center">

          <div class="hit-widget-container hit-widget_nav_menu">

            <h4 class="hit-title-widget">{{ $t("message.imprint") }}</h4>

            <ul class="hit-list-unstyled hit-clear-margins">

              <li class="hit-html-li"><router-link class="hit-html-a hit-text-primary" @click.native="scroll_top()" :to="{ name: 'privacy', params: {lang: $store.getters.lang} }">{{ $t('message.privacy') }}</router-link></li>
              <li class="hit-html-li"><router-link class="hit-html-a hit-text-primary" @click.native="scroll_top()" :to="{ name: 'terms', params: {lang: $store.getters.lang} }">{{ $t('message.terms') }}</router-link></li>
              <li class="hit-html-li"><router-link class="hit-html-a hit-text-primary" @click.native="scroll_top()" :to="{ name: 'imprint', params: {lang: $store.getters.lang} }">{{ $t('message.imprint') }}</router-link></li>
              <li class="hit-html-li"><a href="#" class="hit-html-a hit-text-primary" @click.prevent="set_cookie_settings()">{{ $t('message.cookie') }}</a></li>

            </ul>

          </div>

        </div>

      </div>
    </div>
  </div>

</footer>

</template>

<script>

import logo from '@core/components/assets/logo.vue'
import changeLanguage from '@core/components/assets/hit_change_language.vue'

export default{
  components: {logo, changeLanguage},
  methods: {
    get_version () {
      if (typeof process === 'undefined') { return '' }

      return 'v' + process.env.VUE_APP_VERSION
    },
    get_year () {
      return new Date().getFullYear()
    },
    scroll_top () {
      window.scrollTo(0, 0)
    },
    set_cookie_settings () {
      localStorage.removeItem('hit_cookie_settings')

      this.$store.commit('set_cookie', '')

      setTimeout(function () {
        this.$router.push({name: 'cookie', params: this.$route.params})
      }.bind(this), 200)
    }

  }
}
</script>
